import Research from './research/LabResearchInitialState'

const { Record } = require('immutable')

export default Record({
    research: Research()
})
